export const FormFieldErrorComponent = {
  bindings: {
    messageError: '<',
    errorInfos: '<',
  },
  templateUrl:
    'missions/form/components/form-field-error/form-field-error.html',
};
